var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#1169F4;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#40CD94;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill:#F2F2F2;}\n\t.st3{fill:#40CD94;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 38.1,
    y1: 70,
    x2: 48.3,
    y2: 62.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 161.9,
    y1: 70,
    x2: 151.7,
    y2: 62.3
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "48.3,78.2 48.3,24.9 136.7,24.9 151.7,41.3 151.7,78.2  "
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 100,
    cy: 170.6,
    rx: 64,
    ry: 4.4
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "112.1,111.8 161.9,70 161.9,149.4 38.1,149.4 38.1,70 88.3,112.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.1,149.4l53-39c5.5-4.1,12.5-4.1,18,0l53,39"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "136.5,25.1 136.5,42.5 151,42.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M120.2,65.7c0-0.8-0.1-1.6-0.2-2.3c-0.2-1.5-0.6-3.1-1.2-4.5c-1.1-2.9-2.9-5.7-5.3-7.8 c-2.4-2.2-5.3-3.7-8.4-4.4c-3.1-0.7-6.4-0.7-9.5,0.1c-3.1,0.7-6,2.2-8.5,4.3c-2.4,2-4.4,4.6-5.7,7.6c-2.6,5.8-2.3,12.8,0.8,18.4 c1.5,2.8,3.7,5.2,6.3,7c2.6,1.8,5.6,3,8.7,3.5c3.1,0.5,6.3,0.2,9.4-0.7c3-0.9,5.8-2.6,8-4.8l-2.6-2.7c-3.8,3.5-9.2,5-14.2,4.1 c-5-0.8-9.5-4.1-11.9-8.6c-2.4-4.4-2.6-10-0.5-14.6c2-4.6,6.3-8.2,11.2-9.4c4.9-1.2,10.3-0.1,14.1,3.2c1.9,1.7,3.3,3.8,4.3,6.2 c0.5,1.2,0.8,2.4,1,3.7c0.1,0.6,0.2,1.3,0.2,1.9c0,0.3,0,0.6,0,1c0,0.2,0,0.5,0,0.8c-0.3,2.4-0.9,4.9-2.7,6.6 c-0.9,0.8-2,1.5-3.3,1.8c-0.3,0.1-0.7,0.2-0.9,0.2c-0.3,0-0.6,0-0.9,0c-0.6,0-1.2-0.3-1.5-0.6c-0.3-0.4-0.3-0.7-0.3-1.2 c0-0.4,0.2-0.9,0.3-1.5l0.5-2c0.2-0.7,0.4-1.4,0.5-2.1c0.7-2.8,1.5-6.3,1.9-9.1l-3.8,0c-0.1,0.5-0.3,1-0.4,1.4 c-1.5-1.8-3.7-3-6.2-3c-4.6,0-8.3,4.1-8.3,9.1c0,5,3.7,9.1,8.3,9.1c1.5,0,3-0.5,4.2-1.3c0.3,1,1.1,1.9,2,2.3 c0.9,0.4,1.8,0.6,2.6,0.6c0.4,0,0.8,0,1.2,0c0.4,0,0.8-0.1,1.2-0.1c1.5-0.2,3.1-0.7,4.5-1.6c1.4-0.9,2.6-2.1,3.5-3.5 c0.9-1.4,1.4-3,1.6-4.6c0.1-0.4,0.1-0.8,0.1-1.3C120.2,66.4,120.3,66.1,120.2,65.7z M99.4,72.6c-2.5,0-4.6-2.4-4.6-5.4 c0-3,2.1-5.4,4.6-5.4c2.5,0,4.6,2.4,4.6,5.4C104,70.2,102,72.6,99.4,72.6z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.1c5373c134ab416a110325e2b50bb222.svg";
export { ForwardRef as ReactComponent };